import React, { useCallback, useEffect, useState } from 'react'
import message from 'antd/lib/message'

import { apiManager } from 'helpers'

import { CloseIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'
import DarkPrimaryButton from 'components/DarkPrimaryButton'
import ProfileLabel from 'components/Profile/ProfileLabel'
import ProfileTextarea from 'components/Profile/ProfileTextarea'

const NewFeedbackModal = ({ user, show, onClose, onComplete }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [text, setText] = useState('')

  useEffect(() => {
    if (!show) {
      setText('')
    }
  }, [show])

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      try {
        setIsSubmitting(true)

        await apiManager.adminCreateMatchFeedback({
          userId: user.id,
          text,
        })

        message.success('Match feedback added successfully', 2.5)
        onComplete()
      } catch (error) {
        message.destroy()
        message.error(error.message || 'Please try again')
      } finally {
        setIsSubmitting(false)
      }
    },
    [user, text, onComplete]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="w-screen max-w-3xl px-10 rounded-t-3xl overflow-y-scroll">
        <div className="relative w-full p-5 max-w-full rounded-2xl bg-white md:p-8">
          <button className="bg-transparent text-black absolute top-8 right-4" onClick={onClose}>
            <CloseIcon className="w-4 h-4" />
          </button>
          <div className="text-black text-center underline text-2xl font-bold font-ownersWide mb-8">
            Add Match Feedback
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-8">
              <ProfileLabel className="text-black font-semibold">Feedback</ProfileLabel>
              <ProfileTextarea
                name="text"
                required={true}
                value={text}
                classNames={{
                  input: 'w-full md:max-w-full',
                }}
                onChange={e => setText(e.target.value)}
              />
            </div>
            <div className="flex">
              <button
                className="mr-5 h-14 w-40 border-solid border-2 rounded-xl border-black bg-white font-semibold text-base"
                onClick={onClose}
              >
                Cancel
              </button>
              <DarkPrimaryButton className="flex-grow" loading={isSubmitting} type="submit">
                Add
              </DarkPrimaryButton>
            </div>
          </form>
        </div>
      </Modal>
    </Overlay>
  )
}

export default NewFeedbackModal
